
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.344 9.233a5.227 5.227 0 001.37-1.774c.321-.68.487-1.418.487-2.165 0-1.404-.575-2.75-1.6-3.743A5.551 5.551 0 008.74 0a5.551 5.551 0 00-3.862 1.55 5.213 5.213 0 00-1.6 3.744c0 .747.166 1.486.486 2.165.32.68.788 1.285 1.371 1.774a8.668 8.668 0 00-3.737 3.122A8.283 8.283 0 000 16.94c0 .281.115.55.32.749.205.198.483.31.772.31.29 0 .568-.112.773-.31.205-.199.32-.468.32-.749 0-1.685.69-3.3 1.92-4.492a6.661 6.661 0 014.634-1.86c1.738 0 3.406.669 4.635 1.86a6.256 6.256 0 011.92 4.492c0 .281.115.55.32.749.204.198.482.31.772.31.29 0 .567-.112.772-.31.205-.199.32-.468.32-.749a8.283 8.283 0 00-1.397-4.586 8.668 8.668 0 00-3.737-3.122zM8.739 8.47a3.352 3.352 0 01-1.82-.536A3.2 3.2 0 015.71 6.51a3.086 3.086 0 01-.186-1.836 3.147 3.147 0 01.897-1.626 3.31 3.31 0 011.678-.87 3.374 3.374 0 011.893.181c.6.24 1.11.648 1.471 1.17.36.523.552 1.137.552 1.765 0 .843-.345 1.65-.96 2.246a3.33 3.33 0 01-2.317.93zm10.64.338a5.226 5.226 0 001.315-2.714 5.147 5.147 0 00-.417-2.971A5.344 5.344 0 0018.26.849 5.588 5.588 0 0015.294 0c-.29 0-.568.112-.773.31-.205.199-.32.468-.32.749 0 .28.115.55.32.749.205.198.483.31.772.31.87 0 1.703.334 2.318.93.614.596.96 1.404.96 2.246a3.102 3.102 0 01-.442 1.584c-.287.48-.7.88-1.197 1.158-.162.091-.297.22-.393.376a1.035 1.035 0 00.338 1.424l.427.276.142.074a7.574 7.574 0 013.201 2.76 7.244 7.244 0 011.168 3.995c0 .281.115.55.32.749.205.198.483.31.772.31.29 0 .568-.112.773-.31.205-.199.32-.468.32-.749a9.3 9.3 0 00-1.22-4.648 9.662 9.662 0 00-3.401-3.484z","fill":"#fff"}})])
          )
        }
      }
    